import { Query } from '@cubejs-client/core';
import { CubeQuery } from '@/types/cube';
import { isArray, compact } from 'lodash-es';
import { SECURITY_BYPASS_FILTER } from './countryFilterMapping';
import { resolveCountryFilters } from './resolveCountryFilters';

export type UnsanitizedQuery = Omit<Query, 'filters'> & { filters?: unknown };

function normalizeFilters(query: CubeQuery | UnsanitizedQuery) {
  if (!('filters' in query)) return undefined;
  const { filters } = query;
  return isArray(filters) ? compact(filters) : undefined;
}

function addSecurityBypassFilter(query: CubeQuery | UnsanitizedQuery) {
  return {
    ...query,
    filters: [...(normalizeFilters(query) || []), SECURITY_BYPASS_FILTER],
  };
}

export function sanitizeCubeQuery(
  query: CubeQuery | CubeQuery[] | UnsanitizedQuery | UnsanitizedQuery[] | undefined,
  applySecurityContext: boolean,
  preserveDefaultCountryFilter = false,
) {
  if (!query) return undefined;

  const process = (singleQuery: CubeQuery | UnsanitizedQuery) => {
    if (!applySecurityContext) return addSecurityBypassFilter(singleQuery);
    const filters = normalizeFilters(singleQuery);
    if (!filters?.length) return { ...singleQuery, filters };
    return resolveCountryFilters({ ...singleQuery, filters }, filters, preserveDefaultCountryFilter);
  };

  const processedQuery = Array.isArray(query) ? query.map(process) : process(query);

  return processedQuery as Query;
}
